import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';

import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logoo} alt="yacht_agent_kos" />
      </div>
       {/* <ul className='app__navbar-links'> 
         <li className='p__opensans'><a href="#home">Home</a></li>
         <li className='p__opensans'><a href="#about">About</a></li>
         <li className='p__opensans'><a href="#menu">Services</a></li> 
       </ul>  */}
       
      <div className='app__navbar-smallscreen'>
         <div className='app__navbar-login'>
           <a href="#contact" className='p__opensans'>Contact</a>
           <div className='red'/>
           {/* <a href="/" className='p__opensans'>Plan Your Arrival</a> */}
         </div> 
         
        { <GiHamburgerMenu color='#fff' fontSize={27} onClick={() => setToggleMenu(true)} /> }
        
        {toggleMenu && ( 
           <div className='app__navbar-smallscreen_overlay flex__centerr slide-bottomm'>
             <MdOutlineRestaurantMenu  fontSize={27} className='overlay__close' onClick={() => setToggleMenu(false)} />
             <ul className='app__navbar-smallscreen_links' onClick={() => setToggleMenu(false)}>
                <li className='p__opensans'><a href="#home">Home</a></li>
                <li className='p__opensans'><a href="#plan-your-arrival">Plan Your Arrival</a></li> 
                <li className='p__opensans'><a href="#gallery">Gallery</a></li>
                <li className='p__opensans'><a href="#services">Services</a></li>
                <li className='p__opensans'><a href="#contact">Contact</a></li>
                <li className='p__opensans'><a href="#aboutUs">About Us</a></li>
             </ul>     
           </div>
        )}     
      </div>
   </nav>
 )
};
export default Navbar;
